import type { JDSDropdownMenuSubMenuInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDropdownMenuSubMenuInternalProps>
  ): React.FC<JDSDropdownMenuSubMenuInternalProps> =>
  (props: JDSDropdownMenuSubMenuInternalProps) => {
    return <Component {...props} />;
  };
